import React, { useEffect, useState, useRef } from "react";
import useScore from "./useScore";
import Spinner from "../Spinner/Spinner";
import Text from "../Text/Text";
import ScoreContainer from "../ScoreContainer/index";
import CurrentRanking from "../CurrentRanking";
import { TOTAL_SCORE } from "../hooks/useQuestions";
import Modal from "../Modal/Modal";
import styles from "./ScoreScreen.module.scss";
import Form from "../Form";
import useOnClickOutside from "../hooks/useOnClickOutside";

/** Returns the screen displaying the users score & cta */

function ScoreScreen(props) {
  /** Manufacture the delay for computing the scores */
  const { questions } = props;
  const [scoresReady, setScoresReady] = useState(false);
  const [modalShown, toggleModal] = useState(false);
  const formRef = useRef();
  const [scores, recommendations] = useScore(questions);
  const totalScore = scores.reduce((acc, curr) => acc + curr.score, 0);

  /** The total score is 96, but the user can only ever reach 48 */
  const currentRankingPercentage = (totalScore / TOTAL_SCORE) * 100;

  useEffect(() => {
    const timeout = setTimeout(() => {
      setScoresReady(true);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);
  const handleModal = () => {
    toggleModal((prev) => !prev);
  };
  useOnClickOutside(formRef, () => toggleModal(false));

  function getActiveRank(percentage) {
    if (percentage <= 25) return "Nascent";
    if (percentage > 25 && percentage <= 50) return "Developing";

    return "Nascent";
  }

  if (!scoresReady) return <ScoreLoading />;
  const rankingText = getActiveRank(currentRankingPercentage);
  return (
    <>
      <ScoreContainer
        rankingText={rankingText}
        recommendations={recommendations}
        scores={scores}
        handleModal={handleModal}
      />
      <CurrentRanking
        rankingPercentage={currentRankingPercentage}
        rankingText={rankingText}
      />
      {modalShown ? (
        <Modal>
          <Form
            scores={scores}
            ranking={currentRankingPercentage}
            ref={formRef}
            handleModal={handleModal}
          />
        </Modal>
      ) : null}
    </>
  );
}

function ScoreLoading() {
  return (
    <section className={styles.loading_section}>
      <div className={styles.loading_wrapper}>
        <Spinner color="purple" size="xl" className={styles.loading_spinner} />
        <Text
          className={styles.loading_text}
          variant="subheading"
          weight="bold"
        >
          Crunching the numbers...
        </Text>
      </div>
    </section>
  );
}

export default ScoreScreen;
